import React from 'react'
import Left_menu from './Left_menu'
import Header from './Header'
import Create_order_nav from './Create_order_nav'
import axios from 'axios'
import queryString from 'query-string';
import { useNavigate,useLocation } from 'react-router-dom';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap";
// import './customer_style.css';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';


import Swal from 'sweetalert2'

import ReactLoading from 'react-loading';
import config from "../../config"
import { useNetworkState } from 'react-use';
import Order_left_panel from './Order_left_panel'
import { parse } from 'papaparse'
import Footer from '../Footer'

const Create_order_1 = () => {
   let navigate = useNavigate()
   const location = useLocation()
   const isOnline = useNetworkState();
   console.log("isONline  === " ,isOnline )
   // console.log("location==>122", location)
    let  parsed = queryString.parse(location.search);
   //  console.log("parsed",parsed);
   const [defaultCountry, setDefaultCountry] = React.useState({country_id:0})

   const [selectedOption, setSelectedOption] = React.useState(null);
   // console.log("selectedOption === " , selectedOption)
   const [selectedOption1, setSelectedOption1] = React.useState(null);

   const [options, setOptions] = React.useState([]);
   const[addstate , addSetState] = React.useState({receiver_name:"",receiver_email:"",receiver_mobile:"",receiver_address:"",receiver_country: "", receiver_country_code: "", receiver_postal_code: "", receiver_city: "", receiver_state_name:"",receiver_city_id:"" , receiver_state_id:"", mode:"",error:{} });
   // console.log("addstate==== " , addstate)
   const[domesticmode,setdomesticmodeState] = React.useState({domestic:false})
   const [returnstate, setReturnState] = React.useState({return_name:"",return_city:"",return_country_code:"",return_postal_code:"", return_mobile: "", return_address: "", return_email: "",return_state_name:"" , return_country:""})
   // console.log("returnstate === " , returnstate)
   const[checkboxstate,setcheckboxState]=React.useState(true)
   const[internationalmode,setinternationalmodeState] = React.useState({international:false})
   const[addressState, setaddressState] = React.useState([]);
   const[selected,setSelected ] = React.useState(null)
   const [errorState, setErrorState] = React.useState({receiver_mobile:"" , receiver_email:"" })
   const [countryList, setcountryList] = React.useState([]);
   const [stateList, setStateList] = React.useState([]);
   const [cityList, setCityList] = React.useState([]);
   const [pincodeList, setPincodeList] = React.useState([]);
   const[country,setCountry] = React.useState({country_id:""})
   const[state,setState] = React.useState({state_id:""})
   const[city,setCity] = React.useState({city_id:""})
   const [pincode, setPincode] = React.useState('');
 const [newstate, setnewState] = React.useState('');
 const [newcity, setnewCity] = React.useState('');
 const [newstateid, setnewStateid] = React.useState('');
 const [newcityid, setnewCityid] = React.useState('');
 const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);
 
 const[carriertype,setcarriertype]= React.useState({type:1})
 const[ordertype,setordertype]= React.useState({type:1})


    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        const homeSection = document.querySelector('.home-section');
        if (homeSection) {
            homeSection.classList.toggle('sidebar-closed');
        }
    };
   let userDetail = localStorage.getItem('ship_rocket_user');
   
   // console.log("userDetail====", config.UserId);
   let userData = {};
   if (userDetail != null) {
     userData = JSON.parse(userDetail)
   }

   React.useEffect(()=>{
      
       getCountryList()
       list()

  
     },[])

     React.useEffect(() => {
       if (parsed.receiver_postal_code && parsed.receiver_postal_code.length >= 3) {
         // Fetch details based on the pincode from the URL
         handlePincodeChange({ target: { value: parsed.receiver_postal_code } });
       }
     }, [parsed.receiver_postal_code , country.country_id]);

   const Toast = Swal.mixin({
       toast: true,
       position: 'bottom-end',
       showConfirmButton: false,
       timer: 3000
     })
  
     React.useEffect(()=>{
       if(parsed.carrier_type){
        setcarriertype({type:parsed.carrier_type})
       }
     },[parsed.carrier_type])

     React.useEffect(()=>{
      if(parsed.order_type){
       setordertype({type:parsed.order_type})
      }
    },[parsed.order_type])
   
     // const onChangeLocationstate = (e) => {
     //   // console.log("e general name ",e.target.name);
     //   //  console.log("e general value ",e.target.value);
        
        
     //  let values =   Object.assign({},e.target.value.split(',') )
     // //  console.log("first",values[0])
     //  setState({state_id:values[0]})
     //   addSetState({...addstate , receiver_state_name:values[2], receiver_state_id:values[0], receiver_city:"" , receiver_postal_code:""})
     //   setSelectedOption(null)
     //   setOptions([])
     //   setCityList([])
     //    getCityList({state_id:values[0], country_id:values[1]})
      
     // }
     // const onChangeLocationcity = (e) => {
     //   // console.log("e general name ",e.target.name);
     //   //  console.log("e general value ",e.target.value);
     //    let values =   Object.assign({},e.target.value.split(',') )

     //   setCity({city_id:values[0]})
     //   addSetState({...addstate , receiver_city:values[1], receiver_city_id:values[0], receiver_postal_code:""})
     //    getPincodeList(values[0])
     //    setSelectedOption(null)
     
      
     // }

     const fetchDetailsFromPincode = async (enteredPincode) => {
       try {
         // Replace 'your-api-endpoint' with the actual endpoint of your backend
         const url = config.apiUrl + '/country/automate_pincode';
         
         // Assuming your API expects a POST request with the entered pincode
         const sendData = { enteredPincode , country_id: country.country_id};
         console.log("sendData == " , sendData)
     
         const response = await axios.post(url, sendData);
     
         // Assuming your API returns an object with state and city properties
         const { state, city , state_id , city_id } = response.data;
     
         return { state, city , state_id , city_id };
       } catch (error) {
         console.error('Error fetching details:', error);
         return {
           state: '',
           city: '',
           state_id:'',
           city_id:'',
         };
       }
     };
     const handlePincodeChange = async (e) => {
       const newPincode = e.target.value;
   
       // Update pincode state
       setPincode(newPincode);
   
       // Check if the length is at least three characters
       if (newPincode.length >= 3) {
         // Fetch details based on the pincode
         const { state: newState, city: newCity , state_id: newStateid , city_id:newCityid } = await fetchDetailsFromPincode(newPincode);
   
         // Update state and city inputs
         setnewState(newState);
         setnewCity(newCity);
         setnewStateid(newStateid);
         setnewCityid(newCityid);
       } else {
         // Reset state and city if the pincode is less than three characters
         setnewState('');
         setnewCity('');
       }
     };
     const getCountryList = () => {


       let url = config.apiUrl + '/country/country_list';
       let sendData = {limit:300 , status:1};
       // console.log("bb", sendData);
       axios.post(url, sendData, { headers: config.headers }).then((res) => {
           // console.log("res ", res);           
           setcountryList(res.data.output)
   
   
       }).catch((e) => {
   
   
       });
   }
   const getStateList = (country_id) => {


       let url = config.apiUrl + '/country/state_list';
       let sendData = { t_country_id: country_id, limit: 1000 };
       //  console.log("bb", sendData);
       axios.post(url, sendData, { headers: config.headers }).then((res) => {
           //  console.log("state ", res);           
           setStateList(res.data.output)
   
   
       }).catch((e) => {
   
   
       });
   }
  
      const getPincodeList = async (value) => {
       try {
         // console.log("value", value);
         let url = config.apiUrl + '/country/pincode_list';
         let sendData = { city_id: value };
         // console.log("bb", sendData);
         
         const response = await axios.post(url, sendData, { headers: config.headers });
         
         setPincodeList(response.data.output);
         let data = response.data.output;
         const transformedOptions = data.map(item => ({
           value: item.postal_code,
           label: item.postal_code
         }));
         // console.log("transformedOptions == ", transformedOptions);
         setOptions(transformedOptions);
         const matchedOption = transformedOptions.find(option => option.value === parsed.receiver_postal_code);
         // console.log("matchedOption",matchedOption)
         if (matchedOption) {
           setSelectedOption(matchedOption);
         }
         
      
       } catch (error) {
         // console.error(error);
         throw error; 
       }
     };
     
     
     
     const getCityList = (value) => {
     
     //  console.log("value",value)
      let url = config.apiUrl + '/country/city_list';
         let sendData = { state_id: value.state_id,country_id:value.country_id, limit: 1000 };
         // console.log("bb", sendData);
         axios.post(url, sendData, { headers: config.headers }).then((res) => {
             // console.log("city  ", res);           
             setCityList(res.data.output)
     
     
         }).catch((e) => {
     
     
         });
     }

     const list = async()=>{
       if(parsed.value==0){
       let url = config.apiUrl + '/country/country_list';
       let senddata = {}
       const responseJson = await axios.post(url, senddata, { headers: config.headers });
           //  console.log("responseJson => ", responseJson.data.defaultCountry);
      
           setDefaultCountry(responseJson.data.defaultCountry)
           addSetState({...addstate, receiver_country:responseJson.data.defaultCountryName , receiver_country_code:responseJson.data.defaultCountrycode ,  receiver_name:parsed.receiver_name?parsed.receiver_name:"" , receiver_mobile:parsed.receiver_mobile?parsed.receiver_mobile:"" , receiver_email:parsed.receiver_email?parsed.receiver_email:"" , receiver_address:parsed.receiver_address?parsed.receiver_address:"" , receiver_state_name:parsed.receiver_state_name?parsed.receiver_state_name:"" , receiver_city:parsed.receiver_city?parsed.receiver_city:"" , receiver_postal_code: parsed.receiver_postal_code?parsed.receiver_postal_code:"" ,receiver_city_id:parsed.receiver_city_id?parsed.receiver_city_id:"" , receiver_state_id:parsed.receiver_state_id?parsed.receiver_state_id:"" ,  mode:parsed.mode?parsed.mode:"Domestic" })
           // setSelectedOption(parsed.receiver_postal_code?parsed.receiver_postal_code:null)
         
           setStateList([])
           setCityList([])
   
           // setOptions([])
            setCountry({country_id:responseJson.data.defaultCountry})
          //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
              getStateList(responseJson.data.defaultCountry)

              if(parsed.receiver_state_id!=undefined && parsed.receiver_state_id!=""){
               getCityList({state_id:parsed.receiver_state_id, country_id:responseJson.data.defaultCountry})
               if(parsed.receiver_city_id!=undefined && parsed.receiver_city_id!=""){
                let pincode = await getPincodeList(parsed.receiver_city_id) 
//  console.log("pincode == " , pincode)
                 // if(pincode==true){
                 // if(parsed.receiver_postal_code!=undefined && parsed.receiver_postal_code!=""){
                 //   console.log("options-=----" , options)
                 //   const matchedOption = options.find(option => option.value === parsed.receiver_postal_code);
                 //   console.log("matchedOption",matchedOption)
                 //   if (matchedOption) {
                 //     setSelectedOption(matchedOption);
                 //   }
                 //     // selectOptionByPincode(parsed.receiver_postal_code)
                   
                  
              
                 //  }
                 // }
              }
             
             }
      
        
       }
       else{
           setdomesticmodeState({...domesticmode,domestic:false})
           setinternationalmodeState({...internationalmode,international:true})
            addSetState({...addstate,mode:"International" , receiver_country:"" , receiver_country_code:"" , receiver_city:"" , receiver_postal_code:"" , receiver_state_name:""})
            setSelectedOption(null)
            setOptions([])
          
            setCountry({country_id:""})
            setCityList([])
          //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
         setStateList([])
       }
     }
     // const selectOptionByPincode = (pincode) => {
     
     // };
     const handleChange=(e)=>{
       // console.log("namess",e.target.name)
       // console.log("value",e.target.value)
       
       let names = e.target.name
       let value= e.target.value

      
      
       if(e.target.type=="text"){
           addSetState({...addstate,[e.target.name]:value})
       }
       else if(e.target.type=="radio"){
           if(e.target.checked==true){
               if(e.target.name=="mode_domestic"){
                   setdomesticmodeState({...domesticmode,domestic:true})
                   setinternationalmodeState({...internationalmode,international:false})
                   //  addSetState({...addstate,mode:"Domestic"})
                        let url = config.apiUrl + '/country/country_list';
                        let senddata = {}
                        axios.post(url, senddata, { headers: config.headers })
                          .then((responseJson) => {
                             // console.log("responseJson => ", responseJson.data.defaultCountry);
                       
                            setDefaultCountry(responseJson.data.defaultCountry)
                            addSetState({...addstate ,mode:"Domestic", receiver_country:responseJson.data.defaultCountryName , receiver_country_code:responseJson.data.defaultCountrycode , receiver_city:"" , receiver_state_name:"" , receiver_postal_code:""})
                            setStateList([])
                            setCityList([])
                            setSelectedOption(null)
                            setOptions([])
                             setCountry({country_id:responseJson.data.defaultCountry})
                           //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
                               getStateList(responseJson.data.defaultCountry)
                       
                          })
                          .catch((error) => {
                            
                           //  console.error(error);
                          });
                      

               }
               else if(e.target.name=="mode_international"){
                   setdomesticmodeState({...domesticmode,domestic:false})
                   setinternationalmodeState({...internationalmode,international:true})
                    addSetState({...addstate,mode:"International" , receiver_country:"" , receiver_country_code:"" , receiver_city:"" , receiver_postal_code:"" , receiver_state_name:""})
                    setSelectedOption(null)
                    setOptions([])
                  
                    setCountry({country_id:""})
                    setCityList([])
                  //  setaddState({...addstate , country_name:responseJson.data.defaultCountry})
                 setStateList([])
               }
             
           }
       }
       else if(e.target.type=="number"){
           var re = new RegExp("^.{10}$");
           // console.log(value,"   regex number check =   ",re.test(value))
           setErrorState({ ...errorState, receiver_mobile: "" })
           if (re.test(value)) {
             re = new RegExp("^[0-9]+$");
             if (!re.test(value)) {
               setErrorState({ ...errorState, receiver_mobile: "Please enter valid number" })
               //console.log("please enter valid number")
             }
           } else {
             setErrorState({ ...errorState, receiver_mobile: "Please enter 10 digit number " })
            // return(null)
             //console.log("please check length")
           }
           addSetState({...addstate,[e.target.name]:value})
       }
       else if(e.target.type=="email"){
           setErrorState({ ...errorState, receiver_email: "" })
           addSetState({...addstate , receiver_email:e.target.value})
       }
      
      
      
   }
   // const onChangeLocationpincode =(e)=>{
   //     addSetState({...addstate,receiver_postal_code:e.target.value})
   // }
   // const handleSelectChange = selectedOption => {
   //   // console.log("selectedOption ......++++" , selectedOption)
   //     setSelectedOption(selectedOption);
   //      addSetState({...addstate, receiver_postal_code:selectedOption})
   //   };
   
     
   const next_step=()=>{
     let cleanedReceiverAddress = addstate.receiver_address;

     // Check if '#' exists in receiver_address, then remove it
     if (cleanedReceiverAddress.includes('#')) {
       cleanedReceiverAddress = cleanedReceiverAddress.replace(/#/g, '');
     }
       let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

       // if ( re.test(addstate.receiver_email) ) {
         
            if(addstate.receiver_name!=""){
               //  if(addstate.receiver_email!=""){
                   if (re.test(addstate.receiver_email!=""?addstate.receiver_email:"abc@gmail.com") ) {
                   if(addstate.receiver_mobile!=""){
                       if(addstate.receiver_mobile.length==10){
                           if(addstate.receiver_address!=""){
                    if(addstate.receiver_country!=""){
                     if(pincode!=""){
                        if(newcity!=""){
                           if(newstate!=""){
                              
                               navigate({
                                   pathname: '/customer/create_order_2',
                                   search: `receiver_name=${addstate.receiver_name}&receiver_email=${addstate.receiver_email!=""?addstate.receiver_email:""}&receiver_mobile=${addstate.receiver_mobile}&receiver_address=${cleanedReceiverAddress}&receiver_country=${addstate.receiver_country}&receiver_country_code=${addstate.receiver_country_code}&receiver_postal_code=${pincode}&receiver_city=${newcity}&receiver_state_name=${newstate}&mode=${addstate.mode}&sender_name=${parsed.sender_name?parsed.sender_name:""}&sender_address=${parsed.sender_address?parsed.sender_address:""}&sender_country=${parsed.sender_country?parsed.sender_country:""}&sender_country_code=${parsed.sender_country_code?parsed.sender_country_code:""}&sender_postal_code=${parsed.sender_postal_code?parsed.sender_postal_code:""}&sender_state_name=${parsed.sender_state_name?parsed.sender_state_name:""}&sender_city=${parsed.sender_city?parsed.sender_city:""}&sender_address_id=${parsed.sender_address_id?parsed.sender_address_id:""}&sender_city_id=${parsed.sender_city_id?parsed.sender_city_id:""}&sender_mobile=${parsed.sender_mobile?parsed.sender_mobile:""}&sender_email=${parsed.sender_email?parsed.sender_email:""}&return_name=${parsed.return_name?parsed.return_name:""}&return_email=${parsed.return_email?parsed.return_email:""}&return_mobile=${parsed.return_mobile?parsed.return_mobile:""}&return_address=${parsed.return_address?parsed.return_address:""}&return_country=${parsed.return_country?parsed.return_country:""}&return_country_code=${parsed.return_country_code?parsed.return_country_code:""}&return_postal_code=${parsed.return_postal_code?parsed.return_postal_code:""}&return_city=${parsed.return_city?parsed.return_city:""}&return_state_name=${parsed.return_state_name?parsed.return_state_name:""}&items=${parsed.items?parsed.items:""}&shipment_type=${parsed.shipment_type?parsed.shipment_type:""}&insurance=${parsed.insurance?parsed.insurance:""}&order_id=${parsed.order_id?parsed.order_id:""}&order_date=${parsed.order_date?parsed.order_date:""}&weight=${parsed.weight?parsed.weight:""}&height=${parsed.height?parsed.height:""}&width=${parsed.width?parsed.width:""}&length=${parsed.length?parsed.length:""}&cod_amount=${parsed.cod_amount?parsed.cod_amount:""}&payment_mode=${parsed.payment_mode?parsed.payment_mode:""}&store_id=${parsed.store_id?parsed.store_id:""}&channel_name=${parsed.channel_name?parsed.channel_name:""}&volumetric_weight=${parsed.volumetric_weight?parsed.volumetric_weight:""}&dead_weight=${parsed.dead_weight?parsed.dead_weight:""}&receiver_state_id=${newstateid}&receiver_city_id=${newcityid}&carrier_type=${carriertype.type}&order_type=${ordertype.type}`
                                 });
                                
                           }
                           else{
                               Toast.fire({
                                   background:"rgb(231, 91, 75)",
                                   type: 'unsuccess',
                                   title: "Please Select Receiver Postal Code",
                                   color:"white"
                                 });
                           }
                        }
                        else{
                           Toast.fire({
                               background:"rgb(231, 91, 75)",
                               type: 'unsuccess',
                               title: "Please Select Receiver City",
                               color:"white"
                             });
                        }
              }
              else{
               Toast.fire({
                   background:"rgb(231, 91, 75)",
                   type: 'unsuccess',
                   title: "Please Select Receiver State",
                   color:"white"
                 });
              }
           }
           else{
               Toast.fire({
                   background:"rgb(231, 91, 75)",
                   type: 'unsuccess',
                   title: "Please Select Receiver Country",
                   color:"white"
                 });
           }
       }
       else{
           Toast.fire({
               background:"rgb(231, 91, 75)",
               type: 'unsuccess',
               title: "Please Fill Receiver Address",
               color:"white"
             });
       }
       }else{
           Toast.fire({
               background:"rgb(231, 91, 75)",
               type: 'unsuccess',
               title: "Receiver Mobile must be 10 digit Number",
               color:"white"
             });
       }
       }
       else{
           Toast.fire({
               background:"rgb(231, 91, 75)",
               type: 'unsuccess',
               title: "Please Fill Receiver Mobile",
               color:"white"
             });
       }
   }else{
       setErrorState({...errorState , receiver_email:"Please Enter Valid Email"})
           Toast.fire({
               background:"rgb(231, 91, 75)",
               type: 'unsuccess',
               title: "Please Enter Valid Receiver Email",
               color:"white"
             });
   }
               //  }
               //  else{
               //     Toast.fire({
               //         background:"rgb(231, 91, 75)",
               //         type: 'unsuccess',
               //         title: "Please Fill Receiver Email",
               //         color:"white"
               //       });
               //  }
            }
            else{
               Toast.fire({
                   background:"rgb(231, 91, 75)",
                   type: 'unsuccess',
                   title: "Please Fill Receiver Name",
                   color:"white"
                 });
            }
         
       // }else{
       //     setErrorState({...errorState , receiver_email:"Please Enter Valid Email"})
       //     Toast.fire({
       //         background:"rgb(231, 91, 75)",
       //         type: 'unsuccess',
       //         title: "Please Enter Valid Receiver Email",
       //         color:"white"
       //       });
       // }
   }
   // const checkreturnbox=(e)=>{
   //     if(e.target.checked==true){
   //        setcheckboxState(true)
   //     }
   //     else{
   //       setcheckboxState(false)
   //       setReturnState({return_name:"",return_city:addstate.sender_city ,return_country_code:addstate.sender_country_code,return_postal_code:addstate.sender_postal_code , return_mobile: "", return_address: "", return_email: "",return_state_name:addstate.sender_state_name , return_country:addstate.sender_country})
   //     }
   //   }
     // const handleChangereturn=(e)=>{
     //   setReturnState({...returnstate,[e.target.name]:e.target.value})
     // }
     const onChangeLocationGeneral = (e) => {
       // console.log("e general name ",e.target.name);
       //  console.log("e general value ",e.target.value);
        let values =   Object.assign({},e.target.value.split(',') )
       
        setCountry({country_id:values[0]})
        addSetState({...addstate , receiver_country:values[1] , receiver_country_code:values[2]  })
           getStateList(values[0])
      
     }
     const select_type =(e)=>{
      if(e.target.name=="b2c"){
        setcarriertype({type:1})
      }
      else{
        setcarriertype({type:2})
      }
    }
    const select_order_type =(e)=>{
      if(e.target.name=="normal"){
        setordertype({type:1})
      }
      else{
        setordertype({type:2})
      }
    }
 return (
   <div>
     <Left_menu isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className="home-section">
         
          <Header/>

   <section class="home ">
       {/* <?php include 'header.php';?>  */}
       {/* <Header/> */}

       <Create_order_nav value={1}/>
       {/* <?php include 'create_order_nav.php';?>  */}
       


       <section class="mb-3">
         <div class="">
           <div class="row">
             <div class="col-12 col-md-2">
               {/* <ul class="nav flex-column order_box_left pt-4">
                   <li class="nav-item">
                     <a class="nav-link" href="#">
                       <div class="d-flex ">
                           <div class=""><span class="active">01.</span> </div>
                           <div class="ps-3 ">Buyer Details</div>
                       </div>
                     </a>
                   </li>
                   <li class="nav-item">
                       <a class="nav-link disabled" href="#">
                           <div class="d-flex ">
                               <div class=""><span class="">02</span> </div>
                               <div class="ps-3 ">Pickup Details</div>
                           </div>
                       </a>
                   </li>
                   <li class="nav-item">
                     <a class="nav-link disabled" href="#">
                       <div class="d-flex ">
                           <div class=""><span class="">03</span> </div>
                           <div class="ps-3 ">Order Details</div>
                       </div>
                     </a>
                   </li>
                   <li class="nav-item">
                     <a class="nav-link disabled" href="#">
                       <div class="d-flex ">
                           <div class=""><span class="">04</span> </div>
                           <div class="ps-3 ">Package Details</div>
                       </div>
                     </a>
                   </li>
                 </ul> */}
                 <Order_left_panel value={1}/>
             </div>
             <div class="col-12 col-md">
              <div className='row'>
             {/* <div className='col-md-6'>
              <h4 className='pb-3'>Select Type</h4>
              <div class="row ">
                            <div class="col-12 col-md-3 mb-3">
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" name="b2c" id="inlineRadio1" value="option1" onChange={(e) => select_type(e)} checked={carriertype.type==1}/>
                                  <label class="form-check-label" for="inlineRadio1">B2C</label>
                                </div>
                            </div>
                            <div class="col-12 col-md mb-3">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="b2b" id="inlineRadio1" value="option1" onChange={(e) => select_type(e)} checked={carriertype.type==2} />
                                <label class="form-check-label" for="inlineRadio1">B2B</label>
                              </div>
                            </div>
                        </div>

             </div> */}
             {/* <div className='col-md-6'>
              <h4 className='pb-3'>Select Order Type</h4>
              <div class="row ">
                            <div class="col-12 col-md-3 mb-3">
                                <div class="form-check form-check-inline">
                                  <input class="form-check-input" type="radio" name="normal" id="inlineRadio1" value="option1" onChange={(e) => select_order_type(e)} checked={ordertype.type==1}/>
                                  <label class="form-check-label" for="inlineRadio1">Non-Fulfilled</label>
                                </div>
                            </div>
                            <div class="col-12 col-md mb-3">
                              <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="fulfilled" id="inlineRadio1" value="option1" onChange={(e) => select_order_type(e)} checked={ordertype.type==2} />
                                <label class="form-check-label" for="inlineRadio1">Fulfilled</label>
                              </div>
                            </div>
                        </div>

             </div> */}
             </div>
               <h4 class="pb-3">Add Buyer's Details</h4>
               <div class="card border-0 order_box">
                 <div class="card-body">
                   <section class="pb-5">
                       <h6 class="mb-4">To whom is the order being delivered? <span class="text-muted">(Buyer's Info)</span></h6>
                       <div class="row">
                           <div class="col-12 col-md-4 mb-3">
                               <label for="" class="form-label">Mobile Number: (10 digits)</label>
                               <div class="input-group">
                                   <span class="input-group-text"><i class="fa fa-mobile" aria-hidden="true"></i></span>
                                   <input type="text" class="form-control" placeholder="Enter Buyer's Mobile Number" name="receiver_mobile" onChange={(e)=>handleChange(e)} value={addstate.receiver_mobile}/>
                                   {/* {(errorState.receiver_mobile != "") ?
                                 <label><span className="text-danger">* {errorState.receiver_mobile}</span></label> : ""} */}
                               </div>
                           </div>
                           <div class="col-12 col-md-4 mb-3">
                               <label for="" class="form-label">Full Name:</label>
                               <input type="text" class="form-control" id="" placeholder="Enter Full Name" name="receiver_name" onChange={(e)=>handleChange(e)} value={addstate.receiver_name}/>
                           </div>
                           <div class="col-12 col-md-4 mb-3">
                               <label for="" class="form-label">Email Id:</label>
                               <input type="text" class="form-control" id="" placeholder="Enter Email Id" name="receiver_email" onChange={(e)=>handleChange(e)} value={addstate.receiver_email}/>
                               {(errorState.receiver_email != "") ?
                                 <label><span className="text-danger">* {errorState.receiver_email}</span></label> : ""}
                           </div>
                       </div>
                   </section>

                   <section>
                       <h6 class="mb-4">Where is the order being delivered to? <span class="text-muted">(Buyer's Address)</span></h6>
                       <div class="row">
                           <div class="col-12 col-md-12 mb-3">
                               <label for="" class="form-label">Complete Address:</label>
                               <input type="text" class="form-control" id="" placeholder="Enter Complete Address" name="receiver_address" onChange={(e)=>handleChange(e)} value={addstate.receiver_address} />
                           </div>
                           {parsed.value==1?
                           <div class="col-12 col-md-4 mb-3">
                               <label for="" class="form-label"  >Country:</label>
                               <select class="form-select form-select-sm" name="country_name" onChange={(e)=>onChangeLocationGeneral(e)}>
                               <option >Select</option>
                               {countryList.map((item)=>{
           return (
             <option value={[item.country_id , item.country_name , item.country_code]}>{item.country_name}</option>
         )
          
})}
                               </select>
                           </div>
                           :""}
                           <div class="col-12 col-md-4 mb-3">
                               <label for="" class="form-label"  >Pincode:</label>
                               <input  type='text'  className='form-control' placeholder='Enter Pincode' value={pincode}
       onChange={handlePincodeChange}></input>
                               {/* <select class="form-select form-select-sm" name="state_name" onChange={(e)=>onChangeLocationstate(e)}>
                               <option >{addstate.receiver_state_name!=""?addstate.receiver_state_name:"Select"}</option>
                               {stateList.map((item)=>{
           return (
             <option value={[item.state_id,item.country_id , item.state_name]}>{item.state_name}</option>
         )
          
})}
                               </select> */}
                           </div>
                           <div class="col-12 col-md-4 mb-3">
                               <label for="" class="form-label"  >State:</label>
                               <input className='form-control' type='text' disabled='disabled' value={newstate}></input>
                               {/* <select class="form-select form-select-sm" name="city_name" disabled="disabled" onChange={(e)=>onChangeLocationcity(e)}>
                                 <option>{addstate.receiver_city!=""?addstate.receiver_city:"Select"}</option>
                                 {cityList.map((item)=>{
           return (
             <option value={[item.city_id , item.city_name]}>{item.city_name}</option>
         )
          
})}
                               </select> */}
                           </div>
                           <div class="col-12 col-md-4 mb-3">
                               <label for="" class="form-label">City:</label>
                               <input className='form-control' type='text' disabled='disabled' value={newcity}></input>

                               {/* <Select
  
     placeholder="Select Pincode"
     options={options}
     value={selectedOption}
     onChange={(e)=>handleSelectChange(e)}
     isClearable={true}
     name="pincode"
   /> */}
                           </div>
                       </div>
                   </section>
                   <div class="py-3">
                       {/* <div class="form-check form-check-inline">
                         <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1" checked />
                         <label class="form-check-label" for="inlineCheckbox1">Billing Address is same is Shipping Address</label>
                       </div> */}
                   </div>
                 </div>
               </div>
               <div class="py-4 text-end">
                   <a onClick={()=>next_step()} class="btn btn-primary">Start</a>
               </div>
             </div>
           </div>      
         </div>
       </section>
       
   </section>
   </div>


   {/* <?php include 'footer.php';?> */}
   <Footer/>
   </div>
 )
}

export default Create_order_1
